import draftToHtml from "draftjs-to-html";


export const imageEntityTransform = (nodeName, node) => { // for htmlToDraft so image alignment persists
  if (nodeName === "img" && node instanceof HTMLImageElement) {
    if (node.parentElement instanceof HTMLDivElement) {
      const entityConfig = {};
      const parentElement = node.parentElement;

      if (parentElement.style.float) {
        entityConfig.alignment = parentElement.style.float;
      } else if (parentElement.style.textAlign) {
        entityConfig.alignment = parentElement.style.textAlign;

        if (entityConfig.alignment === "center") {
          entityConfig.alignment = "none";
        }
      }

      entityConfig.src = node.getAttribute
        ? node.getAttribute("src") || node.src
        : node.src;

      entityConfig.alt = node.alt;
      entityConfig.height = node.style.height;
      entityConfig.width = node.style.width;

      return {
        type: "IMAGE",
        mutability: "MUTABLE",
        data: entityConfig,
      };
    }
  }
};

const customEntityTransform = (entity, text) => {
  if (entity.type === "IMAGE") {
    const { src, alignment } = entity.data;
    return `
      <div style="text-align:${alignment || 'center'}">
        <img src="${src}" />
      </div>
    `;
  }
};

export const draftToHtmlCustom = (editorContent) => {
    return draftToHtml(
        editorContent,
        {},
        false,
        customEntityTransform
    );
}